module.exports = __webpack_public_path__ + "img/score_sad.1f0fcc8d.png";